module.exports = __webpack_public_path__ + "img/青春为祖国歌唱.ea690a93.jpg";